const WEEKEND = /^(sat|sun)/i;
const hour = t => Number(String(t || "").split(":")[0]);

// ranges covers every active day's sending window; fromTime/toTime stay as a
// single-range fallback for callers that only know one window.
const scheduleFindings = ({ days, fromTime, toTime, ranges } = {}) => {
  const out = [];
  if (Array.isArray(days) && days.some(d => WEEKEND.test(String(d)))) {
    out.push({ tone: "warn", key: "weekend_sends", label: "Sending on weekends", text: "Weekend cold email gets buried by Monday. Keep it to weekdays." });
  }
  const allRanges = Array.isArray(ranges) && ranges.length
    ? ranges
    : fromTime && toTime
    ? [{ fromTime, toTime }]
    : [];
  const outsider = allRanges.find(r => hour(r.fromTime) < 8 || hour(r.toTime) > 18);
  if (outsider) {
    const fromLabel = outsider.fromLabel || outsider.fromTime;
    const toLabel = outsider.toLabel || outsider.toTime;
    out.push({ tone: "neutral", key: "outside_hours", label: "Sends outside business hours", text: `${fromLabel} to ${toLabel}. Prospects read cold email between 8 and 6 their time.` });
  }
  return out;
};

export default scheduleFindings;
